import { useNavigate, type NavigateOptions, type To } from 'react-router-dom';
import { runInBackground } from '@/lib/utils';
import {
    useBreadcrumbStore,
    type BreadcrumbNavigationSource,
    type BreadcrumbNavigationTarget,
} from '@/store/breadcrumbs';

export interface BreadcrumbNavigateOptions extends NavigateOptions {
    source: BreadcrumbNavigationSource;
    target: BreadcrumbNavigationTarget;
}

export function useBreadcrumbNavigation() {
    const navigate = useNavigate();
    const applyTrackedNavigation = useBreadcrumbStore((state) => state.applyTrackedNavigation);

    return (options: BreadcrumbNavigateOptions) => {
        applyTrackedNavigation(options.source, options.target);

        const destination: To = options.target.url;
        runInBackground(navigate(destination, { replace: options.replace }), () => undefined);
    };
}
